import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import { InputAdornment } from "@material-ui/core";
import {
  sendOTP,
  validateOTP,
  checkOTP,
  userAssign,
  getUserDetails
} from "../../../store/actions/authActionCreators";
import { getFilteredConfig } from "../../../store/actions/userActionCreators";
import { connect } from "react-redux";
import { getSubscriptionStatus } from "../../../store/actions/paymentsActionCreator";
import OtpInput from "react-otp-input";
import { sendError, sendSucces } from "../../../utils/utils";
import Timer from "react-compound-timer";
import { useHistory } from "react-router-dom";
import { SuccessToastMessage } from "../../../utils/utils";
import { trackDwebEvent, loginDwebEvent } from "../../analytics";
import { toast } from "react-toastify";
import SimpleKhataLoginDialog from "../Dialog/SimpleKhataLoginDialog";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

function Copyright() {
  return (
    <Typography
      variant="body2"
      style={{ fontWeight: 600, fontSize: 14, color: "#0b1223" }}
      color="black"
      align="center"
    >
      {"Copyright © "}
      {new Date().getFullYear()}
      {"."}
      {" Crafted with ❤️ in India."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "calc(100vh - 120px)",
  },
  logo: {
    width: "43%",
    height: "auto",
  },
  screenShot: {
    marginTop: "5%",
    width: "71%",
    height: "auto",
  },
  loginBox: {
    marginTop: "20%",
    padding: 32,
    minWidth: "75%",
    boxShadow: "0 11px 40px 0 rgba(0, 0, 0, 0.14)",
    borderRadius: 10,
  },
  footerBox: {
    width: "100%",
    padding: 32,
  },
  loginLogo: {
    width: 199,
    height: 58,
    marginBottom: 24,
  },
  loginLogoFavi: {
    width: 32,
    borderRadius: 6,
  },
  title: {
    color: "#9ea0a5",
    fontSize: 12,
  },
  textV1: {
    marginTop: 6,
    marginBottom: 16,
    width: "100%",
    "& .MuiOutlinedInput-input": {
      textTransform: "capitalize",
    },
  },
  button: {
    width: "100%",
    backgroundColor: "#00976f",
    marginTop: "16px",
    textTransform: "capitalize",
    color: "#fff",
    paddingTop: 10,
    paddingBottom: 10,
    fontWeight: "bold",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#00976f",
    },
  },
  resendOtp: {
    color: "#00976f",
    fontSize: 14,
    cursor: "pointer",
  },
  cancel: {
    color: "red",
  },
}));

const SignInSide = ({
  dispatchLoginAction,
  dispatchGetSubscriptionStatusAction,
  dispatchValidateOtpAction,
  dispatchCheckOtp,
  dispatchAssignUser,
  dispatchGetFilteredConfig,
  dispatchGetUserDetails
}) => {
  const regxMobileNumber = /^\d{10}$/;
  var numRegex = /^\d+$/;
  const classes = useStyles();
  const history = useHistory();
  const [mobileNumber, setMobileNumber] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [otpInputDisabled, setOtpInputDisabled] = useState(false);
  const [otpInputHasError, setOtpInputHasError] = useState(false);
  const [enteredOTP, setEnteredOTP] = useState(null);
  const [resendTimer, setResendTimer] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [simpleKhataDialog, setSimpleKhataDialog] = useState(false);

  const handleMobileNumber = (value, onchange) => {
    if (onchange && otpSent) {
      setOtpSent(false);
      setResendTimer(false);
      setEnteredOTP(null);
      setOtpInputHasError(false);
    }
    if (value) {
      setMobileNumber(value);
      if (value && value.length === 10 && regxMobileNumber.test(value)) {
        setMobileNumberError(false);
      } else if (
        value &&
        value.length === 10 &&
        !regxMobileNumber.test(value)
      ) {
        setMobileNumberError(true);
      } else if (
        !numRegex.test(value)
      ) {
        setMobileNumberError(true);
      }
    } else {
      setMobileNumber(null);
      setMobileNumberError(true);
    }
  };
  const handleGetOTP = () => {
    if (
      mobileNumber &&
      regxMobileNumber.test(mobileNumber) &&
      !mobileNumberError
    ) {
      dispatchLoginAction(
        mobileNumber,
        (data) => {
          if (data && data.status && data.status.code === 200) {
            setOtpSent(true);
            setResendTimer(false);
            sendSucces("Otp Sent Successfully");
          }
        },
        (data) => { }
      );
    }
  };
  const gotoMain = () => {
    history.push({
      pathname: "/",
      state: {
        id: 7,
        pageTitle: "Dashboard",
      },
    });
  };
  const goto500 = () => {
    history.push({
      pathname: "/500",
    });
  };
  const goToPremium = (data) => {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: "Premium",
      },
    });
    // }
  };
  const gotoParties = () => {
    history.push({
      pathname: '/parties',
      state: {
        id: 1,
        pageTitle: 'Parties'
      }
    });
  }
  const validateOTP = (otp) => {
    if (otp.length === 4) {
      dispatchCheckOtp(
        mobileNumber,
        otp,
        (data) => {
          if (data && data.status && data.status.code === 200) {
            loginDwebEvent(data.response.user);
            trackDwebEvent("Login Successfully");
            setOtpInputHasError(false);
            setTimeout(() => {
              if (
                data &&
                data.response &&
                data.response.token &&
                data.response.user
              ) {
                let userInfo = data.response.user;
                if (data.response.user.companyName) {
                  toast.success(
                    <SuccessToastMessage message={"Logged In Successfully!"} />,
                    {
                      className: "toastContainer",
                      closeOnClick: true,
                      closeButton: true,
                      // transition: Zoom,
                      pauseOnHover: false,
                      position:
                        localStorage.getItem("CheckTripOverlay") === null
                          ? "bottom-right"
                          : "top-right",
                    }
                  );
                }
                dispatchAssignUser(data);

                const requestData = {
                  filteredKeys: ["online_payments_config", "dwebSearchBebounceMs", "panRegex", "gstRegex", "pincodeRegex",
                    "GST_STATE_LIST", "subscription", "coming_soon", "VehicleRegex", "event_tracking"]
                }

                dispatchGetUserDetails(
                  (data) => {
                    if (data && data.status && data.status.code == 200) {

                      dispatchGetFilteredConfig(
                        requestData,
                        (data) => {
                          if (data && data.status && data.status.code === 200) {
                            let config = data.response;
                            let pre =
                              config &&
                                config.subscription &&
                                config.subscription.enabled &&
                                config.subscription.enabled == 1
                                ? true
                                : false;
                            if (pre) {
                              dispatchGetSubscriptionStatusAction(
                                (res) => {
                                  if (
                                    res &&
                                    res.status &&
                                    res.status.code === 200 &&
                                    res.response
                                  ) {
                                    let status = res.response;
                                    if (
                                      (status &&
                                        typeof status.isExpired != "undefined" &&
                                        status.isExpired) ||
                                      (userInfo &&
                                        typeof userInfo.isSubscriptionActive !=
                                        "undefined" &&
                                        !userInfo.isSubscriptionActive)
                                    ) {
                                      if (userInfo.role !== "USER") {
                                        goToPremium();
                                      }
                                    } else {
                                      gotoMain();
                                    }
                                  }
                                },
                                () => { }
                              );
                            } else {
                              gotoMain();
                            }
                          }
                        },
                        () => {
                          gotoParties();
                        }
                      );
                    }
                  },
                  () => {

                  }
                )


              }
            }, 500);
          } else if (data && data.status && data.status.code === 500) {
            setOtpInputHasError(true);
          } else if (data && data.status && data.status.code === 400) {
            setOtpInputHasError(true);
          } else if (data && data.status && data.status.code === 465) {
            setMobileNumber(null);
            setOtpInputHasError(false);
            setOtpSent(false);
            setEnteredOTP(null);
            setSimpleKhataDialog(true);
            setResendTimer(false);
          } else {
            sendError("Please Contact Support!");
          }
        },
        (message) => { }
      );
    }
  };
  const handleCheckOtp = (otp) => {
    setEnteredOTP(otp);
    if (otp.length === 4) {
      if (otpInputHasError) {
        setOtpInputHasError(false);
      }
      validateOTP(otp);
    }
  };
  const handleConfirmOTP = (event) => {
    event.preventDefault();
    validateOTP(enteredOTP);
  };
  const handleCloseKhataDialog = () => {
    setSimpleKhataDialog(false);
  };

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={false} sm={false} md={7}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignContent={"space-between"}
            width="100%"
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              width={"100%"}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/logo-small.svg`}
                className={classes.logo}
                alt={"Logo"}
              />
              <img
                src={`${process.env.PUBLIC_URL}/assets/screen-shot.png`}
                className={classes.screenShot}
                alt={"Log"}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={false} sm={false} md={5}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Paper component={'form'} onSubmit={e => { e.preventDefault(); }} className={classes.loginBox}>
              {/* <img
                src={`${process.env.PUBLIC_URL}/assets/logo-small.svg`}
                className={classes.loginLogo}
                alt={"Logo"}
              /> */}
              <Box
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                marginBottom={"16px"}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/logo128.png`}
                  className={classes.loginLogoFavi}
                  alt={"Logo"}
                />
                <Typography
                  align="center"
                  style={{
                    fontWeight: 600,
                    fontSize: 22,
                    color: "#0b1223",
                    marginLeft: 8,
                  }}
                >
                  Login to TransportBook
                </Typography>
              </Box>
              <Box>
                <div className={classes.title}>Mobile Number</div>
                <TextField
                  placeholder="Enter the Mobile Number"
                  name="mobileNumber"
                  value={mobileNumber}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    type: "text",
                    //pattern:'^\d{10}$',
                    maxlength: 10,
                    minlength: 10,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">+91</InputAdornment>
                    ),
                  }}
                  onChange={(e) => handleMobileNumber(e.target.value, true)}
                  onBlur={(e) => handleMobileNumber(e.target.value)}
                  className={classes.textV1}
                  error={mobileNumberError}
                  helperText={
                    mobileNumberError ? "Enter a valid mobile number" : ""
                  }
                />
              </Box>
              {otpSent && (
                <Box>
                  <div className={classes.title}>Enter OTP</div>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <OtpInput
                      inputStyle="inputStyle"
                      numInputs={4}
                      isDisabled={otpInputDisabled}
                      hasErrored={otpInputHasError}
                      errorStyle="error"
                      onChange={handleCheckOtp}
                      isInputNum={true}
                      shouldAutoFocus
                      value={enteredOTP}
                    />
                    {otpInputHasError && (
                      <CancelIcon className={classes.cancel} />
                    )}
                  </Box>
                  <div style={{ marginTop: 8 }}>
                    {resendTimer ? (
                      <div
                        className={classes.resendOtp}
                        onClick={() => {
                          setEnteredOTP(null);
                          setResendTimer(false);
                          setOtpInputHasError(false);
                          handleGetOTP();
                        }}
                      >
                        Resend OTP
                      </div>
                    ) : (
                      <Timer
                        initialTime={30000}
                        direction="backward"
                        startImmediately="true"
                        checkpoints={[
                          {
                            time: 0,
                            callback: () => setResendTimer(true),
                          },
                        ]}
                      >
                        <>
                          <div className={classes.mt1}>
                            You can resend OTP in{" "}
                            <strong>
                              <Timer.Seconds />
                            </strong>{" "}
                            seconds.
                          </div>
                        </>
                      </Timer>
                    )}
                  </div>
                </Box>
              )}
              {otpSent ? (
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={classes.button}
                  onClick={handleConfirmOTP}
                  disabled={
                    enteredOTP && enteredOTP.length === 4 ? false : true
                  }
                >
                  Confirm OTP
                </Button>
              ) : (
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  onClick={handleGetOTP}
                  disabled={
                    mobileNumber &&
                      regxMobileNumber.test(mobileNumber) &&
                      !mobileNumberError
                      ? false
                      : true
                  }
                  className={classes.button}
                >
                  Get OTP
                </Button>
              )}
            </Paper>
          </Box>
        </Grid>
      </Grid>
      <footer>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          className={classes.footerBox}
        >
          <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/shield.svg`}
              className={classes.shield}
              alt={"shield"}
            />
            <Typography
              style={{
                fontWeight: 600,
                fontSize: 16,
                color: "#0b1223",
                marginLeft: 16,
              }}
            >
              100% Safe & Secure
            </Typography>
            {/* <div
              style={{
                width: 1,
                backgroundColor: "#989da2",
                margin: "0 8px",
                height: 28,
              }}
            ></div> */}
            <img
              style={{ marginLeft: 16 }}
              src={`${process.env.PUBLIC_URL}/assets/life-time.svg`}
              alt={"free for lifetime"}
            />
            <Typography
              style={{ fontWeight: 600, fontSize: 16, color: "#0b1223" }}
            >
              Lifetime Free App
            </Typography>
          </Box>
          {/* <Typography style={{ fontSize: 12, color: "#0b1223" }}>
            Privacy Policy •Terms and Conditions
          </Typography> */}
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"end"}
          >
            <Copyright />
          </Box>
        </Box>
      </footer>
      {simpleKhataDialog && (
        <SimpleKhataLoginDialog
          open={simpleKhataDialog}
          onClose={handleCloseKhataDialog}
        ></SimpleKhataLoginDialog>
      )}

    </>
  );
};
const mapDispatchToProps = (dispatch) => ({
  dispatchLoginAction: (mobileNumber, onSuccess, onError) =>
    dispatch(sendOTP({ mobileNumber }, onSuccess, onError)),
  dispatchValidateOtpAction: (mobileNumber, OTP, onSuccess, onError) =>
    dispatch(
      validateOTP({ number: mobileNumber, otp: OTP }, onSuccess, onError)
    ),
  dispatchCheckOtp: (mobileNumber, OTP, onSuccess, onError) =>
    dispatch(checkOTP({ number: mobileNumber, otp: OTP }, onSuccess, onError)),
  dispatchAssignUser: (userInfo) => dispatch(userAssign(userInfo)),
  dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionStatus(onSuccess, onFailure));
  },
  dispatchGetFilteredConfig: (data, onSuccess, onFailure) => {
    dispatch(getFilteredConfig(data, onSuccess, onFailure))
  },
  dispatchGetUserDetails: (onSuccess, onFailure) => {
    dispatch(getUserDetails(onSuccess, onFailure))
  }

});
export default connect(null, mapDispatchToProps)(SignInSide);
